'use strict'

import { analytics } from '../../common/baseData'

class ProductList {
  constructor (params) {
    this.params = params
    this.pagenation = null
    this.sending = false
    this.initEvents()
  }

  set params (params) {
    this._params = params
  }

  get params () {
    return this._params
  }

  set pagen (object) {
    this.pagenation = object
  }

  get pagen () {
    return this.pagenation
  }

  initEvents () {
    // В вашем компоненте или скрипте, где используется Analytics
    if (this.params && this.params.promotionData &&
        this.params.promotionData.items &&
        this.params.promotionData.items.length > 0) {
      // Отправляем событие просмотра акции
      analytics.view_promotion(
          this.params.promotionData,
          'PromotionBanner-' + this.params.promotionData.promotion_id,
          'promotion_detail_page'
      );
    }

    let self = this
    if (this.params.node instanceof HTMLElement) {
      [].slice.apply(self.params.node.querySelectorAll('.product-item[data-container="product"] .relink-value'))
        .forEach(relink => {
          relink.addEventListener('mouseover', event => {
            let product_node = relink.closest('.product-item');
            let image_node = product_node.querySelector('.img img');
            image_node.src = relink.dataset.image;
          });

          relink.addEventListener('mouseleave', event => {
            let product_node = relink.closest('.product-item');
            let image_node = product_node.querySelector('.img img');
            image_node.src = image_node.dataset.src;
          });
        })

      // product link click event
      this.params.node.addEventListener('click', event => (this.onItemClick(event)))

      // product list items view event
      if ("IntersectionObserver" in window) {

        let lazyBlockObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let item_ids = []
              let items = [].slice.apply(self.params.node.querySelectorAll('.product-item[data-container="product"]'))

              items.forEach(item => {
                if (item.dataset.id) {
                  item_ids.push(Number(item.dataset.id))
                }
              })

              if (item_ids.length)
                analytics.viewItemList(item_ids, 'Category Products', 'category_products')
                .then(response => {
                  analytics.view_item_list(response.events[0].params);
                  console.info(response)
                })
                .catch(reason => (console.error(reason)))

              let lazyBlock = entry.target
              lazyBlockObserver.unobserve(lazyBlock)
            }
          })
        })

        lazyBlockObserver.observe(this.params.node)
      } else {
        console.log('IntersectionObserver not supported')
        // Possibly fall back to a more compatible method here
      }
    }
  }

  /**
   * Click event on product link
   * Send analytics select item event
   * @param event
   */
  onItemClick (event) {
    let target = event.target
    //console.info(target)
    let parent = target.closest('.product-item[data-container="product"]')
    //console.info(parent)
    if (!(parent instanceof HTMLElement)) return

    let item_id = parent.dataset.hasOwnProperty('id') ? Number(parent.dataset.id) : null
    //console.info(href, item_id)
    if (item_id === null) return

    window.sessionStorage.setItem('select_item_category', item_id.toString())
  }

  loadNextPage (element) {
    let self = this
    return new Promise((resolve, reject) => {
      let formData = new FormData()
      let xhr = new XMLHttpRequest()

      formData.append('template', self.params.templateName)
      formData.append('parameters', self.params.arParams)
      formData.append('sessid', self.params.sessid)
      formData.append('siteId', self.params.siteId)
      formData.append('page', self.pagen.getNavNextPageNumber())
      formData.append('ajax_filter', self.params.ajax_filter)
      formData.append('languageId', self.params.languageId)
      formData.append('filterPreviewData', self.params.filterPreviewData)
      formData.append('fuserId', self.params.fuserId)
      if (self.params.hasOwnProperty('q'))
        formData.append('q', self.params.q)
      if (self.params.hasOwnProperty('category'))
        formData.append('category', self.params.category)

      xhr.open('POST', self.params.ajaxPath, true)

      xhr.onload = function () {
        if (xhr.status != 200)
          reject(new Error('Network Error'))
        else {
          resolve(this.responseText)
        }
      }
      xhr.onerror = function () {
        reject(new Error('Network Error'))
      }
      self.sending = true
      xhr.send(formData)
    })
  }
}

export { ProductList }